import { render, staticRenderFns } from "./NoticeBlock.vue?vue&type=template&id=04275dae&"
import script from "./NoticeBlock.vue?vue&type=script&lang=js&"
export * from "./NoticeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports